import styles from "./rank.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const stylesModal = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  heading: {
    color: '#000000',
  },
  dialog: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    width: '300px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  },
  dialogTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
  },
  button: {
    margin: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    transition: 'background-color 0.3s',
  },
  buttonCancel: {
    backgroundColor: '#dc3545',
  },
};

export default function Withdraw() {
  const navigate = useNavigate();
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
  });
  const [turnoverAmount, setTurnoverAmount] = useState("");
  const [rankInputs, setRankInputs] = useState({
    bronze: 0,
    silver: 0,
    gold: 0,
    platinum: 0,
    diamond: 0,
    king: 0,
    royal_king: 0,
  });
  const [isOpen, setIsOpen] = useState(false);


  const getDistribuitonData = async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.rankDistributions}?fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}`,
        { headers }
      );
      setLoading(false);
      setData(res?.data?.result);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  };

  const distributionRewardData = async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      const body = {
        fromDate: parameter?.fromDate,
        toDate: parameter?.toDate,
        turnover: {
          Bronze: rankInputs.bronze,
          Silver: rankInputs.silver,
          Gold: rankInputs.gold,
          Platinum: rankInputs.platinum,
          Diamond: rankInputs.diamond,
          King: rankInputs.king,
          "Royal King": rankInputs.royal_king,
        }
      }
      setLoading(true);
      const res = await axios.post(
        `${apiConfig.rankRewardDistributions}`,
        body,
        { headers }
      );
      if (res.data.statusCode === 200) {
        setLoading(false);
        setIsOpen(false);
        toast.success("Reward Distributed");
      }
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  };

  const getRewardPercent = (id) => {
    switch (id) {
      case "Bronze":
        return "1.0";
      case "Silver":
        return "0.8";
      case "Gold":
        return "0.7";
      case "Platinum":
        return "0.5";
      case "Diamond":
        return "0.5";
      case "King":
        return "0.5";
      case "Royal King":
        return "1.0";
      default:
        return 0;
    }
  }

  const tabularData = () => {
    return (
      <>
        <div className={styles.tableWrallerUser}>
          <table>
            <tr>
              <th className={styles.flexTableData}>
                No.
              </th>
              <th>User Name</th>
              <th>Total Investments</th>
              <th>Status</th>
              <th>Sponsor Id</th>
              <th>Strong Team BV</th>
              <th>Weak Team BV</th>
              <th>Monthly Strong Team BV</th>
              <th>Monthly Weak Team BV</th>
              <th>Rank</th>
            </tr>
            {tableData?.map((item, index) => {
              return (
                <tr>
                  <td className={styles.flexTableData}>

                    {index + 1}
                  </td>
                  <td>
                    {item?.nickName}{" "}

                  </td>
                  <td>
                    {item?.totalPlanPrice}{" "}

                  </td>
                  <td>
                    {item?.planSubscription === true ? "Active" : "Inactive"}
                  </td>

                  <td>{item?.invitationCode}</td>
                  <td>{item?.strongTeamBV}</td>
                  <td>{item?.weakTeamBV}</td>
                  <td>{item?.thisMonthStrongTeamBV}</td>
                  <td>{item?.thisMonthWeakTeamBV}</td>
                  <td>{item?.rank}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </>
    );
  }

  const normalizeRank = (rank) => {
    if (!rank) return rank;
    return rank
      .toLowerCase()
      .replace(/\s+/g, "_");
  };

  const calculateRankValues = useCallback(() => {
    setRankInputs((prevState) => ({
      ...prevState,
      bronze: turnoverAmount * getRewardPercent("Bronze") / 100,
      silver: turnoverAmount * getRewardPercent("Silver") / 100,
      gold: turnoverAmount * getRewardPercent("Gold") / 100,
      platinum: turnoverAmount * getRewardPercent("Platinum") / 100,
      diamond: turnoverAmount * getRewardPercent("Diamond") / 100,
      king: turnoverAmount * getRewardPercent("King") / 100,
      royal_king: turnoverAmount * getRewardPercent("Royal King") / 100,
    }));
  }, [turnoverAmount]);

  useEffect(() => {
    calculateRankValues();
  }, [calculateRankValues]);

  const handleInputChange = (e, rank) => {
    const { value } = e.target;
    setRankInputs((prevState) => ({
      ...prevState,
      [rank]: parseFloat(value)
    }));
  };

  const turnoverCalculator = (noOfUser, rank) => {
    const normalizedRank = normalizeRank(rank);

    if (rankInputs[normalizedRank] !== undefined) {
      const result = rankInputs[normalizedRank] / noOfUser;
      return result;
    }

    return 0;
  };

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Rank Income Distribution</h1>

      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={getDistribuitonData}
            >
              Get Data
            </button>
          </div>
        </div>
      </div>
      {data.length === 0 ? null : (
        <>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`} style={{
            marginTop: "2rem", flexDirection: "row", alignItems: "end", justifyContent: "space-between", width: "100%",
            maxWidth: "640px", gap: "2%"
          }}>
            <div style={{ width: "100%" }}>
              <span>Calculate the Turnover</span>
              <div className={styles.inputBoxChild}>
                <input
                  type="number"
                  placeholder="Turnover"
                  className={styles.inputField}
                  onChange={(e) => {
                    setTurnoverAmount(e.target.value);
                  }}
                  value={turnoverAmount}
                />
              </div>
            </div>

            <button
              className={styles.downloadBtn}
              style={{ maxWidth: "207px", width: "100%" }}
              onClick={() => setIsOpen(true)}
              disabled={!turnoverAmount || turnoverAmount === ""}
            >
              Distribute Rewards
            </button>
            {isOpen && (
              <div style={stylesModal.overlay}>
                <div style={stylesModal.dialog}>
                  <h2 style={stylesModal.heading}>Are you sure you want to confirm?</h2>
                  <div>
                    <button onClick={distributionRewardData} style={stylesModal.button}>
                      Yes
                    </button>
                    <button onClick={() => setIsOpen(false)} style={stylesModal.button}>
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>
          <div className={`${styles.inputBox} ${styles.gridContainerInput}`} style={{ marginTop: "1rem", width: "100%" }}>
            {Object.keys(rankInputs).map((rank) => (
              <div key={rank}>
                <span>{rank.charAt(0).toUpperCase() + rank.slice(1).replace('_', ' ')}</span>
                <div className={styles.inputBoxChild}>
                  <input
                    type="number"
                    name={rank}
                    placeholder={rank.charAt(0).toUpperCase() + rank.slice(1).replace('_', ' ')}
                    className={styles.inputField}
                    onChange={(e) => handleInputChange(e, rank)}
                    value={rankInputs[rank]}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <div className={styles.gridContainer}>
          {data?.map((item) => (
            <div className={styles.dashboardContainer} key={item._id} onClick={() => { setStatus(true); setTableData(item?.users) }}>
              <div className={styles.countBox}>
                <div className={styles.label}>Rank : {item?._id}</div>
                <div className={styles.label}>Users : {item?.users.length}</div>
                <div className={styles.label}>Reward Percentage : {getRewardPercent(item?._id)}%</div>
                <div className={styles.label}>Average Reward : {turnoverCalculator(item?.users.length, item?._id)}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {status &&
        tabularData()
      }
    </div>
  );
}
